import { InspectorServiceTravelRuleAddRequest, InspectorServiceTravelRuleDeleteRequest, InspectorServiceTravelRuleGetRequest, InspectorServiceTravelRuleResponse, InspectorServiceTravelRuleUpdateRequest } from "interfaces/Mueller.Business.Models";
import { WebApiRequest, HTTP_POST, HTTP_PUT, HTTP_DELETE } from "../../tools/webservice";
import { Ref } from "react";

export const getInspectorTravelRules = (payload: Partial<InspectorServiceTravelRuleGetRequest>, successCallback, mountedRef: Ref<boolean>) =>
  WebApiRequest({
    method: HTTP_POST,
    endpoint: "/inspector-travel-rules/list",
    payload,
    successCallback,
    mountedRef
  });

  export const addInspectorTravelRule = (payload: InspectorServiceTravelRuleAddRequest, successCallback: (rule: InspectorServiceTravelRuleResponse) => void, errorCallback: (rule: Response) => void, mountedRef: Ref<boolean>) =>
  WebApiRequest({
    method: HTTP_POST,
    endpoint: "/inspector-travel-rules",
    payload,
    successCallback,
    errorCallback: e => errorCallback(e.response),
    disableDefaultErrorResponseHandler: true,
    mountedRef
  });

  export const updateInspectorTravelRule = (payload: InspectorServiceTravelRuleUpdateRequest, successCallback: (rule: InspectorServiceTravelRuleResponse) => void, errorCallback: (rule: Response) => void, mountedRef: Ref<boolean>) =>
  WebApiRequest({
    method: HTTP_PUT,
    endpoint: `/inspector-travel-rules/${payload.travelRuleId}`,
    payload,
    successCallback,
    errorCallback: e => errorCallback(e.response),
    disableDefaultErrorResponseHandler: true,
    mountedRef
  });

export const deleteInspectorTravelRule = (payload: InspectorServiceTravelRuleDeleteRequest, successCallback: () => void, mountedRef: Ref<boolean>) =>
  WebApiRequest({
    method: HTTP_DELETE,
    endpoint: `/inspector-travel-rules/${payload.travelRuleId}`,
    payload,
    successCallback,
    mountedRef
  });
